import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import Axios from '../../config/axios';
import Globals from '../../config/globals';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../css/table.css';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';
import { takeWhile } from 'rxjs/operators';

import NumberFormat from 'react-number-format';

import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import ReactLoading from 'react-loading';

import { allCategories, allInsuranceCompanies, getAllReasonsForDeletion, getPatientInformationByIDNew } from '../../common/services/ApiService';

import { toast } from '@rickylandino/react-messages';
import { Select, Modal } from 'antd';
import { getLoadInfo, updateUserWorklistSortPreference } from '../../common/services/UsersService';

import PatientExamPane from '../Exams/PatientExamPane';
import { calculateAge } from '../Helpers/PatientHelper';
import { getPatientExamResults, getPatientExamResultsForMultipleExams } from '../../common/services/ExamService';
import MwlAdder from '../Patient/MwlAdder';

class WorklistHome extends Component {
    _isMounted = false;

    static getDerivedStateFromProps(nextProps, prevState) {

        if (Globals.selectedFacility.facilityID && (nextProps.selectedFacility.facilityID) && (nextProps.selectedFacility !== prevState.selectedFacility)) {
            return {
                selectedFacility: nextProps.selectedFacility,
                facilitySelected: true
            }
        }

        return null;
    }

    constructor(props) {
        super(props);

        var nowDate = new Date();
        this.mwlDate = nowDate.getFullYear() + '/' + (nowDate.getMonth() + 1) + '/' + nowDate.getDate();
        
        this.state = {
            formFields: {
                searchField: '',
                modality: '',
                studyDate: new Date(this.mwlDate)
            },
            patients: [],
            dicomPatients: [],
            filteredList: [],
            selectedFacility: {},
            facilitySelected: false,
            showPane: false,
            loadingPatients: false,
            selectedPatient: {},
            providersList: [],
            expanded: [],
            selectedDicomPatient: {},
            selectedProvider: {},
            selectedDates: {
                startDate: new Date(),
                endDate: new Date()
            },
            selectedCategories: [],
            insuranceList: [],
            selectedFacilityID: '',
            userAssociatedFacilities: Globals.associatedFacilities,
            openingChart: false,
            showAddExamPane: false,
            selectedExamHistory: [],
            showDeletionModal: false, 
            multipleExamsInfo: [],
            mwl: {},
            deletionReasons: []
        }

    }

    componentDidMount() {
        this._isMounted = true;

        let defaultFacility = JSON.parse(window.sessionStorage.getItem("defaultFacility"));

        allCategories.pipe(takeWhile(() => this._isMounted)).subscribe(data => {
            this.setState({
                allCategories: data
            });
        });

        if (this.state.userAssociatedFacilities?.length === 0) {
            var user = JSON.parse(window.sessionStorage.getItem("userInfo"));
            getLoadInfo(user.userId).then(data => {
                Globals.associatedFacilities = data.userAssociatedFacilities;
                this.setState({
                    userAssociatedFacilities: data.userAssociatedFacilities
                });
            });
        }

        if (defaultFacility.facilityID) {
            let formFields = this.state.formFields;
            formFields.facilityID = defaultFacility.facilityID;

            let selectedFacilityID = defaultFacility.facilityID;

            this.setState({
                selectedFacility: defaultFacility,
                selectedFacilityID,
                facilitySelected: true,
                loading: true,
                formFields
            }, () => { this.getAllDicomPatientsByFacility(); this.getProvidersByFacility(); this.getInsuranceByFacility(); });
        } else {
            this.getAllDicomPatientsByFacility();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this._isMounted) {
            if (Globals.selectedFacility.facilityID && (this.props.selectedFacility.facilityID) && (this.props.selectedFacility.facilityID !== prevState.selectedFacility.facilityID)) {
                this.setState({
                    loading: true
                });
                this.getAllDicomPatientsByFacility();
            }
        }
        
    }

    getAllDicomPatientsByFacility = () => {
        if (this.state.selectedFacility?.facilityID) {
            let params = {
                facilityID: this.state.selectedFacility.facilityID,
                ianaTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }
            //add startDate and endDate to params to filter by date range if needed in the future and convert to string format of yyyy-MM-dd
            if (this.state.selectedDates.startDate && this.state.selectedDates.endDate) {
                params.startDate = Moment(this.state.selectedDates.startDate).format('YYYY-MM-DD');
                params.endDate = Moment(this.state.selectedDates.endDate).format('YYYY-MM-DD');
            } else if (this.state.selectedDates.startDate) {
                params.startDate = Moment(this.state.selectedDates.startDate).format('YYYY-MM-DD');
            } else if (this.state.selectedDates.endDate) {
                params.endDate = Moment(this.state.selectedDates.endDate).format('YYYY-MM-DD');
            }
            Axios.get(`/api/GetAllDicomPatientsByFacility`, {
                params
            }).then(response => {
                this.setState({
                    dicomPatients: response.data
                }, () => this.filterByDateRange());

            }).catch(error => {
                console.log(error);
            });
        }
        
    }

    getProvidersByFacility = () => {
        Axios.get(`/api/GetProvidersByFacility`, {
            params: {
                facilityID: this.state.selectedFacility.facilityID
            } 
        }).then(response => {
            let providersList = response.data;
            this.setState({
                providersList
            });
        }).catch(error => {
            console.log(error);
        });
    }

    getInsuranceByFacility = () => {
        Axios.get(`/api/GetInsuranceCompaniesByFacility`, {
            params: {
                facilityID: this.state.selectedFacility.facilityID
            } 
        }).then(response => {
            let insuranceList = response.data;
            this.setState({
                insuranceList
            });
            allInsuranceCompanies.next(insuranceList);
        }).catch(error => {
            console.log(error);
        });
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'providerID') {
            var selectedProvider = this.state.providersList.find(prov => prov.providerID === value);
            this.setState({ selectedProvider });
        }

        if (name === 'facilityID') {
            this.setState({
                facilitySelected: true
            });

            let selectedFacility = this.state.userAssociatedFacilities.find(fac => fac.facilityModel.facilityID === value).facilityModel;
            this.setState({
                selectedFacility,
                facilitySelected: true,
                loading: true
            }, () => { this.getAllDicomPatientsByFacility(); this.getProvidersByFacility(); this.getInsuranceByFacility(); });

            
        }

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });

    }

    handleProviderChange = (value) => {
        var selectedProvider = this.state.providersList.find(prov => prov.providerID === value);
        this.setState({ formFields: { ...this.state.formFields, providerID: value }, selectedProvider });
    }

    handleFacilityChange = (selectedFacilityID) => {

        let selectedFacility = this.state.userAssociatedFacilities.find(fac => fac.facilityModel.facilityID === selectedFacilityID).facilityModel;
        this.setState({
            facilitySelected: true,
            selectedFacility,
            facilitySelected: true,
            loading: true,
            selectedFacilityID,
            formFields: { ...this.state.formFields, facilityID: selectedFacilityID }
        }, () => {
                this.getAllDicomPatientsByFacility();
                this.getProvidersByFacility();
                this.getInsuranceByFacility();
        });
    }

    handleTableDateChange = (name, date) => {
        this.setState({ formFields: { ...this.state.formFields, [name]: date } }, () => {
            if (JSON.stringify(this.state.formFields) !== JSON.stringify(this.formFields)) {
                this.isDirty = true;  // dirty
            }

        });
    }

    handleSbmt = (event) => {
        event.preventDefault();
        let postdata = {
            uniqueID: this.state.selectedFacility && this.state.selectedFacility.facilityID,
            name: this.state.formFields.searchField
        }

        this.setState({
            showPane: true,
            loadingPatients: true
        });

        Axios.post(`/api/GetPatientsByNameOrMRN`, postdata
        ).then(response => {
            this.setState({
                patients: response.data,
                loadingPatients: false,
                selectedPatient: response.data[0]
            })

        }).catch(error => {
            console.log(error);
        });

    }

    updateDicomPatient = () => {
        let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

        let dicom_PatientModel = this.state.formFields;
        dicom_PatientModel.referringPhysiciansFirstName = this.state.selectedProvider ? this.state.selectedProvider.fName : null;
        dicom_PatientModel.referringPhysiciansLastName = this.state.selectedProvider ? this.state.selectedProvider.lName : null;
        dicom_PatientModel.npi = this.state.selectedProvider?.npi || null;
        dicom_PatientModel.referringPhysiciansID = this.state.selectedProvider ? this.state.selectedProvider.providerID : null;
        dicom_PatientModel.userID = userInfo.userId;
        dicom_PatientModel.ianaTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        Axios.post(`/api/UpdateDicomPatient`, dicom_PatientModel
        ).then(response => {
            if (response.data) {

                toast.success("Patient has been updated.");

                this.setState({
                    formFields: {
                        modality: '',
                        studyDate: new Date(this.mwlDate)
                    },
                    expanded: []
                })

                this.getAllDicomPatientsByFacility();
            }
            else {

                toast.error("MRN is not unique. Please try with a unique MRN.");
            }

        }).catch(error => {

            toast.error("Something went wrong. Please log out and try again.");
        });
    }

    deleteDicomPatient = () => {
        getAllReasonsForDeletion().then(data => {
            this.setState({
                showDeletionModal: true,
                deletionReasons: data
            });
        });
    }

    handleDelete = () => {
        if (!this.state.deletionReason) {
            toast.warning("Please fill out a reason for deletion.")
        } else {
            let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
            let dicom_PatientModel = this.state.formFields;

            dicom_PatientModel.userID = userInfo.userId;
            dicom_PatientModel.reasonForDeletion = this.state.deletionReason;

            Axios.post(`/api/DeleteDicomPatient`, dicom_PatientModel
            ).then(response => {

                toast.success("Patient has been deleted.");

                this.setState({
                    formFields: {
                        modality: '',
                        studyDate: new Date(this.mwlDate)
                    },
                    expanded: [],
                    deletionReason: ''
                })

                this.getAllDicomPatientsByFacility();
                this.closeDeleteModal();
            }).catch(error => {
                toast.error("Something went wrong. Please log out and try again.");
            });
        }
    }

    closeDeleteModal = () => {
        this.setState({
            showDeletionModal: false,
            deletionReason: ''
        });
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (e.target.id !== 'deleteIcon' && e.target.id !== 'openChart' && e.target.id !== 'performExam') {
            let expanded = [];
            expanded.push(row.dicom_Patient.suid);
            this.setState(() => ({
                expanded
            }));
        } else {
            this.setState({
                expanded: []
            });
        }
        
    }

    handleBtnClick = () => {

        this.setState(() => ({
            expanded: this.state.expanded.filter(x => x !== 2)
        }));

    }

    selectPatient = (patient) => {
        if (patient && !this.state.openingChart) {
            getPatientInformationByIDNew(patient.patientModel.patientID).then(data => {
                this.setState({
                    selectedPatient: data.patientInformation,
                    openingChart: true
                });

                this.props.history.push({
                    pathname: '/patient-dashboard',
                    state: { selectedObject: data.patientInformation, examInfo: data.examInfo }
                });
            });

            //let postdata = {
            //    uniqueID: patient.patientModel.patientID
            //};

            //Axios.post(`/api/GetAllPatientExamInfoByPatient`, postdata
            //).then(response => {
            //    this.props.history.push({
            //        pathname: '/patient-dashboard',
            //        state: { selectedObject: patient, examInfo: response.data }
            //    });

            //}).catch(error => {
            //    console.log(error);
            //});
        }

    }

    handleNewDateChange = (name, date) => {
        this.setState({ selectedDates: { ...this.state.selectedDates, [name]: date } });
    }

    filterByDateRange = () => {

        let filteredList = this.state.dicomPatients;

        let filterWithModality = [];

        let expandedCats = this.state.selectedCategories.map(sc => {
            let retval = {};

            switch (sc) {
                case 'Screening Mammo':
                    retval = {
                        examClass: 'Screening',
                        modality: 'MG'
                    };
                    break;
                case 'Dx Mammo':
                    retval = {
                        examClass: 'Diagnostic',
                        modality: 'MG'
                    };
                    break;
                case 'US':
                    retval = {
                        examClass: 'Screening',
                        modality: 'US'
                    };
                    break;
                case 'Ultrasound':
                    retval = {
                        examClass: 'Diagnostic',
                        modality: 'US'
                    };
                    break;
                default:
                    break;
            }

            return retval;
        }) || [];

        expandedCats.forEach(c => {
            let fList = filteredList.filter(f => f.dicom_Patient.modality === c.modality && f.dicom_Patient.examClass === c.examClass);
            filterWithModality = filterWithModality.concat(fList);
        });

        if (filterWithModality.length === 0 && this.state.selectedCategories.length === 0) {
            filterWithModality = filteredList;
        }

        this.setState({
            filteredList: [...filterWithModality]
        }, () => {

            let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

            if (userInfo.worklistSortPreference) {
                let splitString = userInfo.worklistSortPreference.split(',');

                let ariaLabel = '';
                if (splitString[0] === 'dicom_Patient.patientsLastName') {
                    ariaLabel = '[aria-label="Last Name sortable"]';
                } else if (splitString[0] === 'dicom_Patient.recordTime') {
                    ariaLabel = '[aria-label="Exam Time sortable"]';
                }

                if (ariaLabel === '') return;
                let headerEl = document?.querySelector(ariaLabel);
                if (headerEl) {
                    //if element exists, simulate click
                    if (splitString[1] === 'desc') {
                        headerEl.click();
                    } else {
                        headerEl.click();

                        setTimeout(() => {
                            if (splitString[0] === 'dicom_Patient.patientsLastName') {
                                ariaLabel = '[aria-label="Last Name sort desc"]';
                            } else if (splitString[0] === 'dicom_Patient.recordTime') {
                                ariaLabel = '[aria-label="Exam Time sort desc"]';
                            }

                            headerEl = document.querySelector(ariaLabel);
                            if (headerEl) {
                                headerEl.click();
                            }
                        }, 200);
                    }
                }
            }
        });
    }

    handleMwlDateChange = (date) => {
        if (date) {
            let mwlTimeFormat = "MMMM d, yyyy h:mm aa";
            if (date.toString().includes('00:00:00'))
                mwlTimeFormat = "MMMM d, yyyy";

            this.setState({ formFields: { ...this.state.formFields, studyDate: date }, mwlTimeFormat });
        }
        
    }

    updateSortPreference = (field, order) => {
        let postdata = {
            userID: JSON.parse(window.sessionStorage.getItem("userInfo")).userId,
            worklistSortPreference: `${field},${order}`
        }
        updateUserWorklistSortPreference(postdata);
        let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
        userInfo.worklistSortPreference = postdata.worklistSortPreference;
        window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    }

    handlePerformExam = (row, multiple = false) => {

        if (!row || multiple) {
            let localList = [...this.state.filteredList]
            let guidList = [];
            localList.forEach(item => {
                var examClass = item.examHistory.find(exam => exam.patientExamModel.patientExamID === item.patientExam.patientExamID)?.examTypeModel?.examclass;
                
                let guidObj = { Key: item.patientExam.patientExamID, Value: examClass }
                guidList.push(guidObj);
            });

            let postdata = {
                guidMap: guidList,
                facilityID: localList[0].patientExam.facilityID,
                userID: JSON.parse(window.sessionStorage.getItem("userInfo")).userId
            };

            getPatientExamResultsForMultipleExams(postdata).then(data => {
                if (data?.length > 0) {

                    let retval = [...data];
                    retval.forEach(item => {
                        var foundRow = localList.find(localObj => localObj.patientExam.patientExamID === item.examInfo.patientExamModel.patientExamID);
                        item.patient = foundRow.patient;
                        item.examHistory = foundRow.examHistory;
                    })

                    //this.setState({
                    //    multipleExamsInfo: data,
                    //    selectedPatientExam: data.examInfo,
                    //    examResults: data.resultInfo,
                    //    sharedFollowUpIDs: data.examIDs,
                    //    selectedPatient: row.patient,
                    //    selectedExamHistory: row.examHistory,
                    //    showAddExamPane: true
                    //});
                } else {
                    toast.error("Something went wrong. Try each exam individually");
                }
            });
        } else {
            var examClass = row.examHistory.find(exam => exam.patientExamModel.patientExamID === row.patientExam.patientExamID)?.patientExamModel?.examclass; //get the exam class from the examHistory)

            let postdata = {
                uniqueID: row.patientExam.patientExamID,
                facilityID: row.patientExam.facilityID,
                name: examClass,
                userID: JSON.parse(window.sessionStorage.getItem("userInfo")).userId
            };

            getPatientExamResults(postdata).then(data => {
                this.setState({
                    selectedPatientExam: data.examInfo,
                    examResults: data.resultInfo,
                    sharedFollowUpIDs: data.examIDs,
                    selectedPatient: row.patient,
                    selectedExamHistory: row.examHistory,
                    showAddExamPane: true
                });
            });
        }
    }

    updateExamInfo = () => {
        var idx = this.state.filteredList.findIndex(x => x.dicom_Patient.suid === this.state.selectedPatientExam?.patientExamModel.suid);

        var localFilteredList = [...this.state.filteredList];
        var listObj = { ...localFilteredList[idx] };
        listObj.patientExam.performedYN = true;
        localFilteredList[idx] = listObj;

        this.setState({
            filteredList: []
        }, () => {
            this.setState({
                filteredList: [...localFilteredList]
            });
        });

        toast.destroy("updating");
    }

    render() {
        const { Option } = Select;

        const mwlFormatter = (cell, row, index) => {
            return (
                <button type="button" id="addToMWL" className="unstyleBtn ml-3" onClick={() => this.setState({ mwl: { isOpen: true, patient: row.patientModel, facility: row.facilityModel, patientID: row.patientModel.patientID, facilityID: row.patientModel.facilityID } })}>
                    <i className="fas fa-share-alt fa-125x color-pink text-center" id="addToMWL"></i>
                </button>
            );
        }

        function fullNameFormatter(cell, row) {
            return (
                <span>{row.dicom_Patient.referringPhysiciansFirstName ? (row.dicom_Patient.referringPhysiciansFirstName + ' ' + row.dicom_Patient.referringPhysiciansLastName) : ''}</span>
            );
        }

        function openChartFormatter(cell, row) {
            return (
                <i className="fas fa-folder-open fa-125x color-pink text-center hover" id="openChart"></i>
            );
        }

        function editFormatter(cell, row) {
            return (
                <i className="fas fa-edit fa-125x color-pink text-center hover" id="editIcon"></i>
            );
        }

        const performExamButton = (cell, row) => {
            //return a button if row.patientExam.performedYN is false, otherwise return a label stating the exam has been performed
            if (!row.patientExam.performedYN) {
                return (
                    <button className="btn btn-submit" id="performExam" onClick={() => this.handlePerformExam(row)}>Perform Exam</button>
                );
            } else {
                return (
                    <label>Exam has been performed</label>
                );
            }
        }

        const columns = [{
            dataField: 'dicom_Patient.studyDate',
            text: 'Exam Date',
            formatter: cell =>
            Moment(new Date(cell)).format('L'),
            sort: true
        }, {
            dataField: 'dicom_Patient.recordTime',
            isDummyField: true,
            text: 'Exam Time',
            formatter: (cell, row) =>
                Moment(new Date(row.dicom_Patient.studyDate)).format('LT'),
            sort: true,
            onSort: (field, order) => {
                this.updateSortPreference(field, order);
            },
            sortValue: (cell, row) =>
                Moment(new Date(row.dicom_Patient.studyDate)).format('LT'),
        }, {
            dataField: 'dicom_Patient.patientsLastName',
            text: 'Last Name',
            title: 'patientsLastName',
            sort: true,
            onSort: (field, order) => {
                this.updateSortPreference(field, order);
            }
        }, {
            dataField: 'dicom_Patient.patientsFirstName',
            text: 'First Name',
            sort: true
        }, {
            dataField: 'dicom_Patient.patientID',
            text: 'Patient ID',
            sort: true
        }, {
            dataField: 'dicom_Patient.patientsBirthDate',
            text: 'DOB',
            formatter: cell => Moment(new Date(cell)).format('L'),
            sort: true,
            sortValue: cell => Moment(new Date(cell)).format('L'),
        }, {
            dataField: 'dicom_Patient.insurance',
            text: 'Insurance',
            sort: true
        }, {
            dataField: 'df1',
            text: 'Referring MD',
            formatter: fullNameFormatter,
            sort: true,
            sortValue: (cell, row) => (row.dicom_Patient.referringPhysiciansFirstName + ' ' + row.dicom_Patient.referringPhysiciansLastName),
            isDummyField: true
        }, {
            dataField: 'dicom_Patient.examType',
            text: 'Exam Type',
            sort: true,
        },{
            dataField: 'dicom_Patient.accessionNumber',
            text: 'Accession Number',
            sort: true,
        }, {
            dataField: 'df2',
            isDummyField: true,
            text: 'Edit',
            formatter: editFormatter
        }, {
            dataField: 'df3',
            isDummyField: true,
            text: 'Open Chart',
            formatter: openChartFormatter
            },
            //{
            //dataField: 'df4',
            //isDummyField: true,
            //text: 'Delete',
            //formatter: deleteFormatter
            //},
            {
            dataField: 'df5',
            isDummyField: true,
            formatter: performExamButton
        }];

        const sizePerPageOptionRenderer = ({
            text,
            page,
            onSizePerPageChange
        }) => (
                <li
                    key={text}
                    role="presentation"
                    className="form-control-custom hover"
                    tabIndex="-1"
                    data-page={page}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        onSizePerPageChange(page);
                    }}
                    style={{ color: 'pink' }}
                >
                    <span
                        tabIndex="-1"
                        role="menuitem"
                        data-page={page}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            onSizePerPageChange(page);
                        }}
                        style={{ color: 'rgba(243, 0, 121, 1)' }}
                    >
                        {text}
                    </span>
                </li>
            );

        const pagination = {
            sizePerPage: 50,
            sizePerPageList: [{ text: "5", value: 5 }, { text: "10", value: 10 }, { text: "50", value: 50 }, { text: "100", value: 100 }], // A numeric array is also available. the purpose of above example is custom the text
            sizePerPageOptionRenderer
        };

        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                var selectedProvider = this.state.providersList.find(prov => (prov.fName + " " + prov.lName) === row.dicom_Patient.referringPhysiciansFirstName + " " + row.dicom_Patient.referringPhysiciansLastName);
                var providerID = selectedProvider ? selectedProvider.providerID : null;
                if (e.target.tagName === 'I' && e.target.id === 'deleteIcon') {
                    let formFields = row.dicom_Patient;
                    formFields.providerID = providerID;
                    formFields.name = row.dicom_Patient.referringPhysiciansFirstName + ' ' + row.dicom_Patient.referringPhysiciansLastName;

                    this.setState({
                        formFields,
                        selectedProvider
                    }, () => this.deleteDicomPatient());

                }
                else if (e.target.tagName === 'I' && e.target.id === 'openChart') {
                    if (!this.state.openingChart) {
                        this.setState({
                            openingChart: true
                        });

                        getPatientInformationByIDNew(row.dicom_Patient.patientGUID).then(data => {
                            this.setState({
                                selectedPatient: data.patientInformation
                            });

                            this.props.history.push({
                                pathname: '/patient-dashboard',
                                state: { selectedObject: data.patientInformation, examInfo: data.examInfo, filteredCategoryList: data.categoryList, patientEthnicity: data.patientEthnicity }
                            });
                        });
                    }
                }
                else {
                    this.handleBtnClick();

                    let formFields = row.dicom_Patient;
                    
                    formFields.providerID = providerID;
                    formFields.name = row.dicom_Patient.referringPhysiciansFirstName + ' ' + row.dicom_Patient.referringPhysiciansLastName;

                    this.setState({
                        formFields,
                        selectedProvider
                    });
                } 
            }
        };

        const patientColumns = [{
            dataField: 'patientModel.mrn',
            text: 'MRN #'
        }, {
            dataField: 'patientModel.lName',
            text: 'Last Name'
        }, {
            dataField: 'patientModel.fName',
            text: 'First Name'
        }, {
            dataField: 'patientModel.dob',
            text: 'DOB',
            formatter: cell => Moment(new Date(cell)).format('L')
        }, {
            dataField: 'facilityModel.facilityName',
            text: 'Facility Name'
        }, {
            isDummyField: true,
            text: 'Add to MWL',
            formatter: mwlFormatter,
            formatExtraData: {
                st: this.state
            }
        }];

        const selectPatientRow = {
            mode: 'radio',
            clickToSelect: true,
            hideSelectColumn: true,
            style: { background: 'pink' },
            selected: [this.state.selectedPatient && this.state.selectedPatient.patientModel && this.state.selectedPatient.patientModel.patientID]
        };

        const rowPatientEvents = {
            onClick: (e, row, rowIndex) => {
                if (e.target.tagName === 'TD' || e.target.tagName === 'TR' || e.target.tagName === 'I') {
                    this.setState({
                        selectedPatient: row
                    });
                }
            }
        };

        const isDatePast = (date) => {
            return Moment(date).isBefore(Moment(), 'day');
        }

        const doesExamHaveResult = (row) => {
            var primaryRes = row.examHistory.find(exam => exam.patientExamModel.patientExamID === row.patientExam.patientExamID)?.primaryResultID;
            return !isGuidEmpty(primaryRes);
        }

        function isGuidEmpty(guid) {
            return guid === null || guid === undefined || guid === '' || guid === '00000000-0000-0000-0000-000000000000';
        }

        const expandRow = {
            renderer: row => (
                <div className="row">
                    <div className="form-group col-lg-2">
                        <label className="form-label">Study Date</label>
                        <DatePicker
                            showTimeSelect
                            className="form-control-custom"
                            onChange={(date) => this.handleTableDateChange('studyDate', date)}
                            selected={this.state.formFields.studyDate ? Moment(this.state.formFields.studyDate).toDate() : null}
                            dateFormat="MM/dd/yyyy hh:mm aa"
                            timeIntervals={15}
                            customInput={
                                <NumberFormat format="##/##/####" mask="_" />
                            }
                            disabled={isDatePast(row.patientExam.examDateTime)}
                        />
                    </div>
                    <div className="form-group col-lg-2">
                        <label className="form-label">Last Name</label>
                        <input type="text" disabled={isDatePast(row.patientExam.examDateTime)} name="patientsLastName" value={this.state.formFields.patientsLastName || ''} onChange={this.handleInputChange} className="form-control-custom" />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">First Name</label>
                        <input type="text" disabled={isDatePast(row.patientExam.examDateTime)} name="patientsFirstName" value={this.state.formFields.patientsFirstName || ''} onChange={this.handleInputChange} className="form-control-custom" />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Patient ID</label>
                        <input type="text" disabled={isDatePast(row.patientExam.examDateTime)} name="patientID" value={this.state.formFields.patientID || ''} onChange={this.handleInputChange} className="form-control-custom" />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">DOB</label>
                        <DatePicker
                            selected={this.state.formFields.patientsBirthDate ? Moment(this.state.formFields.patientsBirthDate).toDate() : null}
                            onChange={(date) => this.handleTableDateChange('patientsBirthDate', date)}
                            className="form-control-custom"
                            customInput={
                                <NumberFormat format="##/##/####" mask="_" />
                            }
                            disabled={isDatePast(row.patientExam.examDateTime)}
                        />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Insurance</label>
                        <select className="form-control-custom" value={this.state.formFields.insuranceID || ''} name="insuranceID" onChange={this.handleInputChange} disabled={isDatePast(row.patientExam.examDateTime)}>
                            <option />
                            {this.state.insuranceList.map((ins, idx) => <option key={ins.insCompName} value={ins.insuranceID} onChange={this.handleInputChange}>{ins.insCompName}</option>)}
                        </select>
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Referring MD</label>
                        <Select
                            allowClear
                            placeholder="Please select"
                            onChange={this.handleProviderChange}
                            className="form-control-custom w-100"
                            bordered={false}
                            value={this.state.formFields.providerID}
                            options={this.state.providersList.map(prov => ({ label: prov.fName + ' ' + prov.lName, value: prov.providerID }))}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            showSearch
                            disabled={this.props.patientInactive || isDatePast(row.patientExam.examDateTime)}

                        />
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Cell Phone #</label>
                        <p>{row.patient.cellPhone || "N/A"}</p>
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Work Phone #</label>
                        <p>{row.patient.workPhone || "N/A"}</p>
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Home Phone #</label>
                        <p>{row.patient.homePhone || "N/A"}</p>
                        <p>{row.patient.workPhoneExt ? "Ext: " + row.patient.workPhoneExt : ""}</p>
                    </div>

                    <div className="form-group col-lg-2">
                        <label className="form-label">Address</label>
                        <p>{[
                            row.patient.address1?.trim(),
                            row.patient.address2?.trim(),
                            row.patient.city?.trim() && `${row.patient.city?.trim()},`,
                            row.patient.state?.trim(),
                            row.patient.zip?.trim()
                        ].filter(Boolean).join(' ').replace(',', ', ')}</p>
                    </div>

                    {!isDatePast(row.patientExam.examDateTime) &&
                        <div className="form-group col-12">
                            {!doesExamHaveResult(row) && <button className="btn btn-danger" onClick={this.deleteDicomPatient}>Delete from MWL</button>}
                            <button className="btn btn-outline-default margin-left-15" onClick={() => this.setState({ expanded: [] })}>Cancel</button>

                            <button className="btn btn-submit float-right" onClick={this.updateDicomPatient}>Update/Resend Entry</button>
                        </div>
                    }
                </div>
            ),
            expanded: this.state.expanded,
            onExpand: this.handleOnExpand,
            onlyOneExpanding: true,
            parentClassName: 'background-pink',
            className: 'background-pink'
        };

        return (
            <div className="">
                <div className="secondary-header">
                    {this.state.userAssociatedFacilities?.length === 1 ?
                        <div className="form-group col-lg-3">
                            <label className="form-label">Facility</label>
                            <div>{this.state.selectedFacility.facilityName}</div>
                        </div>
                        :
                        <div className="form-group col-lg-3">
                            <Select
                                
                                placeholder="Please select"
                                onChange={this.handleFacilityChange}
                                className="form-control-custom w-100"
                                bordered={false}
                                value={this.state.selectedFacilityID}
                                showSearch
                                virtual={false}
                                filterOption={(input, option) => (option.children[0] + option.children[1]).toLowerCase().includes(input.toLowerCase())}
                            >
                                {this.state.userAssociatedFacilities?.filter(item => item.facilityModel.inactiveYN !== 1).map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}
                            </Select>
                        </div>
                    }


                </div>

                

                <div className="panel-hdr pt-6">
                    <h2>
                        Worklists {/*<button onClick={() => sendText()}>Send Text</button>*/}
                    </h2>
                </div>
                
                {this.state.facilitySelected ?
                    <Fragment>
                        <div className="col-md-6 form-group">

                            <form onSubmit={this.handleSbmt}>
                                <label className="form-label">Add Patient</label>
                                <input type="text" name="searchField" value={this.state.formFields.searchField || ''} onChange={this.handleInputChange} className="form-control-custom" placeholder="Search for a patient name or MRN"/>

                                <button className="btn btn-submit mt-3" onClick={this.handleSbmt}>Search Patients</button>
                            </form>
                        </div>


                        <hr /> 
                        <div className="row">
                            <div className="form-group col-lg-4">
                                <label className="form-label">Filter By</label>
                                <DatePicker
                                    onChange={(date) => this.handleNewDateChange('startDate', date)}
                                    selectsStart
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    className="form-control-custom"
                                    showMonthDropdown
                                    showYearDropdown
                                    placeholderText='Start Date'
                                    selected={this.state.selectedDates.startDate && Moment(this.state.selectedDates.startDate).toDate()}
                                    customInput={
                                        <NumberFormat format="##/##/####" mask="_" />
                                    }
                                />

                                <DatePicker
                                    onChange={(date) => this.handleNewDateChange('endDate', date)}
                                    selectsEnd
                                    showMonthDropdown
                                    showYearDropdown
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    className="form-control-custom mt-4"
                                    placeholderText='End Date'
                                    selected={this.state.selectedDates.endDate && Moment(this.state.selectedDates.endDate).toDate()}
                                    customInput={
                                        <NumberFormat format="##/##/####" mask="_" />
                                    }
                                />

                            </div>

                            <div className="form-group col-lg-4">
                                <label className="form-label">Exam Category</label>

                                <Select
                                    mode="multiple"
                                    maxTagCount={1}
                                    onChange={(selectedCategories) => this.setState({ selectedCategories })}
                                    allowClear
                                    placeholder="Please select 1 or more"
                                    className="form-control-custom w-100"
                                    bordered={false}
                                    value={this.state.selectedCategories}
                                >
                                    <Option value='Screening Mammo'>Screening Mammogram</Option>
                                    <Option value='Dx Mammo'>Diagnostic Mammogram</Option>
                                    <Option value='US'>Screening Ultrasound</Option>
                                    <Option value='Ultrasound'>Diagnostic Ultrasound</Option>
                                </Select>

                            </div>

                            <div className="col-6">
                                <button className="btn btn-submit mt-3 ml-3" onClick={this.getAllDicomPatientsByFacility}>Filter</button>
                            </div>
                            {/*this.state.filteredList?.length > 1 &&
                                <div className="col col-6">
                                    <button className="btn btn-submit mt-3 mr-3 float-right" onClick={() => this.handlePerformExam(null, true)}>Perform All Exams</button>
                                </div>
                            */}
                        </div>
                        <div className="col-12">
                            <hr />
                            {this.state.filteredList.length > 0 &&
                                <BootstrapTable
                                    keyField='dicom_Patient.suid'
                                    data={this.state.filteredList}
                                    columns={columns}
                                    pagination={paginationFactory(pagination)}
                                    rowEvents={rowEvents}
                                    expandRow={expandRow}
                                    className="worklist-table"
                                    condensed />
                            }
                        </div>
                    </Fragment>
                    :
                    <h2 className="ml-3 mt-3">Please select a facility first</h2>
                }

                <Modal
                    title="Reason For Deletion"
                    visible={this.state.showDeletionModal}
                    onCancel={this.closeDeleteModal}
                    onOk={this.handleDelete}
                >
                    <div className="row">
                        <div className="form-group col-12">
                            <label className="form-label">Reason for Deletion <span className="color-pink">*</span></label>
                            <select className="form-control-custom" name="deletionReason" value={this.state.deletionReason} onChange={e => { console.log(e.target.value); this.setState({ deletionReason: e.target.value }); }}>
                                <option />
                                {this.state.deletionReasons.map((item, idx) => <option key={idx} value={item.reasonForDeletionID}>{item.reasonForDeletion}</option>)}
                            </select>
                        </div>
                        {/*<div className="form-group col-12">*/}
                        {/*    <label className="form-label">Reason For Deletion <span className="color-pink">*</span></label>*/}
                        {/*    <textarea className="form-control-custom" rows="3" name="deletionReason" value={this.state.deletionReason} onChange={e => this.setState({ deletionReason: e.target.value })} placeholder="Please enter a reason for deletion"></textarea>*/}
                        {/*</div>*/}
                        <div className="form-group col-12">
                            <em className="text-danger"><strong>NOTE:&nbsp;</strong>Deleting this entry will also remove the associated patient exam</em>
                        </div>
                    </div>
                </Modal>

                <SlidingPane
                    className='some-custom-class'
                    overlayClassName='pinkCard'
                    isOpen={this.state.showPane}
                    title='Exam Details'
                    onRequestClose={() => this.setState({ showPane: false })}
                >
                    <div className="slide-pane-body scrollableDiv ">
                        <div className="row">
                            {this.state.loadingPatients ?
                                <span className="frame-heading"><ReactLoading className='tableLoading' type={"spokes"} color={'#F30079'} height={30} width={30} /> Loading ...</span>
                                :

                                <div className="col-12">
                                    <h4>Search Results</h4>
                                    <hr />
                                    {this.state.patients.length > 0 &&
                                        <BootstrapTable
                                            keyField='mrn'
                                            className="table-custom-hover"
                                            data={this.state.patients}
                                            columns={patientColumns}
                                            pagination={paginationFactory(pagination)}
                                            rowEvents={rowPatientEvents}
                                            selectRow={selectPatientRow}
                                            hover condensed />
                                    }

                                </div>
                            }
                        </div>
                    </div>

                    
                </SlidingPane>

                {this.state.showAddExamPane &&
                    <PatientExamPane
                    patientAge={calculateAge(this.state?.selectedPatient?.dob)}
                    patientInactive={false}
                    patient={this.state.selectedPatient}
                    showPane={this.state.showAddExamPane}
                    examInfo={this.state.selectedPatientExam}
                    examHistory={this.state.examResults}
                    facility={this.state.facility}
                    updateExamInfo={this.updateExamInfo}
                    from='worklist'
                    hidePane={() => this.setState({ showAddExamPane: false })}
                    sharedFollowUpIDs={this.state.sharedFollowUpIDs}
                    getNewExamInfo={() => {
                        toast.destroy('loading');
                        toast.destroy("updating");
                        this.getAllDicomPatientsByFacility();
                    }}
                    />
                }

                <MwlAdder info={this.state.mwl} allCategories={this.state.allCategories} close={() => this.setState({ mwl: { mwlOpen: false, patientID: null, facilityID: null } })} />
            </div>
        );
    }
}

export default withRouter(WorklistHome);